import { connect } from 'react-redux';
import { resetPasswordAction } from '@smorder/logic';
import ForgotPassword from './forgot-password';

const mapStateToProps = state => ({
  isLoading: state.authentication.isLoading,
  errorMessage: state.authentication.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  resetPassword: email => dispatch(resetPasswordAction.INIT(email)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPassword);
